var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bizcomp-info-collection bizcomp ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/info' }}},[_vm._v("个人中心")]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.title))])],1)],1),_c('inv-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }